export const promotionabannerUrl = 'j/sitepromo';
export const irisPromotionalbannerUrl = '/content-aggregator/shared-components/zones/SiteWidePromo';
